import { Ajax } from "@story/story_assets/ajax";

document.addEventSelectorListener("change input", "[data-onchange]", function(event, target) {
	let url = target.getAttribute("data-onchange");
	let name = target.getAttribute("name");
	let value = target.value;

	let data = {};
	data[name] = value;

	Ajax.post(url, data);
});